import { GITHUB_INSTALLATION_MESSAGE_ID } from '../components/callback/github-installation-callback.component';
import { Injectable } from '@angular/core';

export interface GithubInstallationResult {
  installationId: string;
  state: string;
}

@Injectable({
  providedIn: 'root',
})
export class LocationService {
  openAuthWindow = (href: string): Promise<boolean> => {
    window.open(href, '_blank', 'popup, width=600, height=600');

    return new Promise((resolve) => {
      const ac = new AbortController();
      window.addEventListener(
        'message',
        (event: MessageEvent) => {
          if (event.origin !== window.location.origin) return;
          if (event.data === 'hsp.github.callback.finished') {
            ac.abort();
            resolve(true);
          }
        },
        { signal: ac.signal },
      );
    });
  };

  openInstallationWindow = (
    href: string,
  ): Promise<GithubInstallationResult | null> => {
    const popup = window.open(href, '_blank', 'popup, width=600, height=600');

    return new Promise((resolve) => {
      const ac = new AbortController();
      let settled = false;

      const done = (result: GithubInstallationResult | null) => {
        if (settled) return;
        settled = true;
        ac.abort();
        clearInterval(pollClosed);
        resolve(result);
      };

      const pollClosed = setInterval(() => {
        if (popup?.closed) {
          // Defer by one microtask so any pending postMessage from the popup
          // is processed before we resolve null (cancel).
          setTimeout(() => {
            done(null);
          }, 0);
        }
      }, 500);

      window.addEventListener(
        'message',
        (event: MessageEvent) => {
          if (event.origin !== window.location.origin) return;
          if (event.data?.id === GITHUB_INSTALLATION_MESSAGE_ID) {
            done({
              installationId: event.data.installationId,
              state: event.data.state,
            });
          }
        },
        { signal: ac.signal },
      );
    });
  };
}
